module.exports = __webpack_public_path__ + "3e482beab3013262af56b49ee9f95403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-mn.png
// module id = 2009
// module chunks = 0